import { render } from "./AlzataAclEditor.vue?vue&type=template&id=680df606"
import script from "./AlzataAclEditor.vue?vue&type=script&lang=js"
export * from "./AlzataAclEditor.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__